import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import BookCard from "../../../components/gcstudent/bookCard/BookCard";
import BookDetailPage from "../../../subsreens/gcstudent/bookdetailpage/BookDetailPage";
import "../../../assets/css/gcstudent/featuredbooksection/FeaturedBooksSection.css";
// ✅ gcStudent-skeleton-* classes LibraryPage.css mein already defined hain —
// same skeleton look ke liye yahi reuse kar rahe hain, naya CSS nahi likha.
import "../../../assets/css/gcstudent/librarypage/LibraryPage.css";

const LATEST_COUNT = 4;

// ✅ Self-contained, reusable section — same data source, same BookCard,
// same BookDetailPage flow (incl. reservation) as LibraryPage.
// Drop this anywhere (e.g. HomePage) with zero extra wiring.
const FeaturedBooksSection = ({ onViewAll }) => {
  const [latestBooks, setLatestBooks] = useState([]);
  const [loading, setLoading]         = useState(true);
  const [selectedBook, setSelectedBook] = useState(null);

  const { baseUrl, authToken } = useContext(AppContext);

  useEffect(() => {
    let mounted = true;

    axios
      .get(`${baseUrl}/general/books/fetchAllBooks`, {
        headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
      })
      .then((res) => {
        if (!mounted) return;
        if (res.data.success) {
          const books = (res.data.books || []).filter(Boolean);

          // Newest first: prefer created_at if backend sends it,
          // else fall back to id (higher id = newer).
          const sorted = [...books].sort((a, b) => {
            if (a.created_at && b.created_at) {
              return new Date(b.created_at) - new Date(a.created_at);
            }
            return (b.id ?? 0) - (a.id ?? 0);
          });

          setLatestBooks(sorted.slice(0, LATEST_COUNT));
        }
      })
      .catch((err) => {
        console.error("Latest books fetch error:", err);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => { mounted = false; };
  }, [baseUrl, authToken]);

  // ── Same pattern as LibraryPage: clicking a card swaps in BookDetailPage,
  // so reservation / all other operations work identically. ──
  if (selectedBook) {
    return (
      <BookDetailPage
        book={selectedBook}
        onBack={() => setSelectedBook(null)}
      />
    );
  }

  if (!loading && latestBooks.length === 0) return null;

  return (
    <div className="gcStudent-featured-section">
      <h2 className="gcStudent-featured-title">Latest Books</h2>
      <p className="gcStudent-featured-subtitle">
        Recently added books to the library
      </p>

      {loading ? (
        <Row
          className="gy-4 gx-3 gcStudent-featured-grid"
          style={{ maxWidth: 1200, margin: "0 auto", display: "flex", flexWrap: "wrap", justifyContent: "center" }}
        >
          {Array.from({ length: LATEST_COUNT }).map((_, i) => (
            <Col key={`skeleton-${i}`} xs={12} sm={6} md={4} lg={3}>
              <div className="gcStudent-skeleton-card">
                <div className="gcStudent-skeleton-img" />
                <div className="gcStudent-skeleton-info">
                  <div className="gcStudent-skeleton-line gcStudent-skeleton-badge" />
                  <div className="gcStudent-skeleton-line gcStudent-skeleton-title" />
                  <div className="gcStudent-skeleton-line gcStudent-skeleton-title-short" />
                  <div className="gcStudent-skeleton-line gcStudent-skeleton-author" />
                  <div className="gcStudent-skeleton-line gcStudent-skeleton-avail" />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <Row
          className="gy-4 gx-3 gcStudent-featured-grid"
          style={{ maxWidth: 1200, margin: "0 auto", display: "flex", flexWrap: "wrap", justifyContent: "center" }}
        >
          {latestBooks.map((book, i) => (
            <Col key={book.id} xs={12} sm={6} md={4} lg={3}>
              <BookCard book={book} index={i} onClick={setSelectedBook} />
            </Col>
          ))}
        </Row>
      )}

      <div className="gcStudent-featured-viewall-row">
        <button className="gcStudent-featured-viewall-btn" onClick={onViewAll}>
          View All Books
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 5l7 7-7 7"
              stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default FeaturedBooksSection;